<template>
  <div class="d-flex flex-column fv-row">
    <label v-if="conf.showLabel" class="d-flex align-items-center dm-fs-0-9-rem fw-bold form-label" :class="{required_star: required}" :for="name"
    >
      <slot name="labelText">{{ label }}</slot>
    </label>
    <treeselect
        class="dm-treeselect-sm fw-bold dm-fs-1-rem mb-3"
        :name="name"
        :placeholder="placeholder"
        :multiple="conf.multiple"
        :clearable="conf.clearable"
        :searchable="conf.searchable"
        :disabled="conf.disabled"
        :open-on-click="conf.openOnClick"
        :open-on-focus="conf.openOnFocus"
        :clear-on-select="conf.clearOnSelect"
        :close-on-select="conf.closeOnSelect"
        :always-open="conf.alwaysOpen"
        :append-to-body="conf.appendToBody"
        :options="options"
        :limit="conf.limit"
        :max-height="conf.maxHeight"
        :value="value"
        @input="emitValue"
        :normalizer="normalizer"
    />
    <has-error v-if="form" :form="form" :field="name"></has-error>
  </div>
</template>

<script>
const config = {
  multiple: false,
  clearable: true,
  searchable: true,
  disabled: false,
  openOnClick: true,
  openOnFocus: false,
  clearOnSelect: false,
  closeOnSelect: true,
  alwaysOpen: false,
  appendToBody: false,
  limit: 10,
  maxHeight: 200,

  id: 'id',
  label: 'label',

  showLabel: true,
}

export default {
  props: {
    value: {
      type: String | Number, // no values must be of type null or undefined
      default: null,
      required: false,
    },
    name: {
      type: String | Number,
      required: true,
    },
    label: {
      type: String | Number,
      required: true,
    },
    placeholder: {
      type: String | Number,
      default: 'Select One'
    },
    required: {
      type: Boolean | Number | Object, // null is an object
      default: true
    },
    form: {
      type: Object,
      default: null,
      required: false,
    },
    config: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      //
    }
  },
  computed: {
    conf(){
      if(!this.config) return {...config};

      return {...config, ...this.config}
    },
  },
  methods: {
    emitValue(value) {
      const val_ = value === undefined ? null : value ;
      this.$emit('input', val_)
    },
    normalizer(node) {
      return {
        id: node[this.conf.id],
        label: node[this.conf.label],
      }
    },
  },
}
</script>